import { CText } from './CText';
import classes from './MainLayout.Menu.module.scss'

export type MainLayoutMenuSpec = {
  label: string;
  value: string;
}

export type MainLayoutMenuProps = {

} & MainLayoutMenuSpec;

export const MainLayoutMenu = (props: MainLayoutMenuProps) => {
  const { label, value } = props;

  return <div className={classes.menuItem}>
    <CText fw='normal'>
      {label}
    </CText>
  </div>
}